/**
 * 実行環境関連 Class
 */
export default class Environment {
  /**
   * トップ階層URL取得
   * @returns {string}
   */
  static getHomeUrl() {
    let homeUrl = '';
    let protocol = location.protocol;
    let host = location.host;
    let pathAry = location.pathname.split('/');
    if (host == 'www.segafredo.jp' && pathAry[1] == 'test') {
      homeUrl = protocol + '//' + host + '/test/';
    } else {
      homeUrl = protocol + '//' + host + '/';
    }
    return homeUrl;
  }
}
